import React from 'react'
import { MENU_ITEMS } from 'constants/menu'
import { URL_TEAMS } from 'constants/links'
import { ACCOUNT } from 'constants/controllers'
import useMenu from 'hooks/useMenu'
import selectHeaderMenu from 'redux/selectors/selectHeaderMenu'
import MobileMenu from './MobileMenu'

const [help] = MENU_ITEMS.filter(item => item.type === 'group')
const [team] = MENU_ITEMS.filter(item => item.url === URL_TEAMS)
const [account] = MENU_ITEMS.filter(item => item.target === ACCOUNT)

const MobileMenuWrapper = ({
  headerHeight,
  isDocDrafter,
  isLogged,
  isExternalAuth,
  flavour,
  pageId,
  aol,
  controller
}) => {
  const sections = useMenu(selectHeaderMenu)

  const items = isLogged
    ? [...sections, team, ...help.items]
    : [
        {
          type: 'group',
          title: 'Resources',
          items: sections
        },
        {
          type: 'group',
          title: 'Solutions',
          items: MENU_ITEMS.filter(item => item.position === 'solution')
        },
        ...MENU_ITEMS.filter(item => item.type === 'group')
      ]

  return (
    <nav
      className='nav-full-right fixed db right0 bottom0 max-w-100 bg-white z30 shadow-black-1 overflow-y-auto scroll-touch flex'
      style={{ top: headerHeight }}
    >
      <MobileMenu
        {...{
          items,
          account,
          isDocDrafter,
          isLogged,
          isExternalAuth,
          flavour,
          pageId,
          aol,
          controller
        }}
      />
    </nav>
  )
}

export default MobileMenuWrapper
